import edBuy from './edbuy.js';

window.$edBuy = edBuy;